"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 3.575 6.786 6.144a.7.7 0 0 1-.541.394l-2.71.36 1.96 2.128a.7.7 0 0 1 .173.602l-.533 2.865 2.55-1.286a.7.7 0 0 1 .63 0l2.55 1.286-.533-2.865a.7.7 0 0 1 .173-.602l1.96-2.129-2.71-.359a.7.7 0 0 1-.54-.394zm-1.147-.849c.458-.97 1.836-.97 2.295 0l1.17 2.475 2.579.341c1.022.136 1.462 1.367.766 2.122l-1.89 2.053.516 2.777c.192 1.03-.877 1.843-1.819 1.368L8 12.616l-2.47 1.246c-.942.475-2.01-.338-1.82-1.368l.518-2.777-1.891-2.053c-.695-.755-.256-1.986.767-2.122l2.579-.341z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StarOutlineIcon16.js.map